import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import {
  reset,
  setLoading,
  setManagedApply,
  INITIAL_MANAGED_APPLY
} from './actions';

const userManagedApplyReducer = handleActions(
  {
    [setManagedApply.toString()]: (_, { payload: applies }) => applies,
    [reset.toString()]: () => INITIAL_MANAGED_APPLY
  },
  INITIAL_MANAGED_APPLY
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  userManagedApply: userManagedApplyReducer,
  loading: loadingReducer
});
